module.exports = __webpack_public_path__ + "static/media/filter_2_white_18dp.b47234cb.svg";